import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { extractMargins } from '../../util/spacing.js';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { isDisabled, mapDismissIconBox, mapReservedSpaceForDismissIcon, mapBoxProps, mapInteractiveDismissIcon, mapDismissIcon } from './BaseChip.mappers.js';

var _excluded = ["onClick", "onDismiss", "dismissLabel", "state", "children"];
var BaseChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var onClick = props.onClick,
    onDismiss = props.onDismiss,
    dismissLabel = props.dismissLabel,
    state = props.state,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var disabled = isDisabled(state);
  var handleClick = React.useCallback(function (event) {
    if (!disabled && onClick) onClick(event);
  }, [disabled, onClick]);
  var dismissBoxProps = mapDismissIconBox(props);
  var theme = useThemeContext();
  var reserveSpaceForDismissIcon = mapReservedSpaceForDismissIcon(theme, props);
  var handleDismiss = React.useCallback(function (event) {
    var _event$nativeEvent;
    event === null || event === void 0 || (_event$nativeEvent = event.nativeEvent) === null || _event$nativeEvent === void 0 || _event$nativeEvent.stopImmediatePropagation();
    event === null || event === void 0 || event.stopPropagation();
    event === null || event === void 0 || event.preventDefault();
    if (!disabled && onDismiss) onDismiss();
  }, [disabled, onDismiss]);
  var _extractMargins = extractMargins(rest),
    margins = _extractMargins.margins,
    restAfterMargin = _extractMargins.rest;
  return /*#__PURE__*/React.createElement(Box, _extends({
    position: "relative"
  }, margins), /*#__PURE__*/React.createElement(Box, _extends({
    as: "button",
    disabled: disabled,
    onClick: handleClick,
    ref: ref
  }, restAfterMargin, mapBoxProps(props)), children, reserveSpaceForDismissIcon && /*#__PURE__*/React.createElement(Box, reserveSpaceForDismissIcon)), dismissBoxProps && /*#__PURE__*/React.createElement(Box, _extends({
    position: "absolute",
    display: "flex"
  }, mapInteractiveDismissIcon(theme, props)), /*#__PURE__*/React.createElement(Box, _extends({}, dismissBoxProps, {
    as: "button",
    disabled: disabled,
    onClick: handleDismiss,
    "aria-label": dismissLabel
  }), /*#__PURE__*/React.createElement(Icon, mapDismissIcon(props)))));
});
BaseChip.defaultProps = {
  selection: 'unselected',
  state: 'enabled',
  size: 'm'
};

export { BaseChip };
//# sourceMappingURL=BaseChip.js.map
